import * as React from 'react';

import { translate } from '~l10n/client';

import NoResultsIcon from '../../../../../../shared/icons/NoResultsIcon';

interface Props {
  lastSearchText: string;
}

export function LegacyNotFoundReport({ lastSearchText }: Props) {
  return (
    <div className="no-reports-found-container">
      <NoResultsIcon className="no-reports-found-icon" />
      <span className="no-reports-found-large-text">
        {translate('No Reports Found')}
      </span>
      <span className="no-reports-found-small-text">
        {translate('Nothing found matching “{0}”.').format(lastSearchText)}
      </span>
      <span className="start-over-text">
        {translate('Delete search terms to start over.')}
      </span>
    </div>
  );
}
